var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tabs',{attrs:{"type":"card","defaultActiveKey":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"Payout"}},[_c('payout')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"Income"}},[_c('income')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }